/**
 * Created by dubaoxing on 2017/3/3.
 */
import { guid } from './helper';
var request = require('superagent');
var api = 'https://cube.meituan.com/ipromotion/cube/toc/component/base/getServerCurrentTime';
var Time = {};
var Queue = {};
var LastUrlTime = 0;
var Lock = false;
let Block = {
    TIME: {}
};
Time._callback = function () {
    for (var key in Queue) {
        if (Queue.hasOwnProperty(key)) {
            var cb = Queue[key];
            // 全部执行回调，已执行的，不再调用
            if (cb) {
                cb(Block.TIME);
                Queue[key] = null;
            }
        }
    }
};
Time._syn = function () {
    // 已发送请求，不再发送
    if (Lock)
        return;
    Lock = true;
    request.get(api).withCredentials().set('Content-Type', 'application/x-www-form-urlencoded').end(function (err, res) {
        var now = Date.now();
        var server = now;
        var diff = 0;
        if (!err && res.ok && res.body.status === 0) {
            server = parseInt(res.body.data) - 300;
            diff = server - now;
        }
        else {
            Lock = false;
        }
        Block.TIME.diff = diff;
        Object.defineProperty(Block.TIME, 'server', {
            get: function get() {
                return Date.now() + this.diff;
            }
        });
        console.log(diff, 'diff', Block.TIME);
        Time._callback();
    });
};
Time.on = function (cb) {
    console.log(Block, Block.TIME, '???');
    // 全局变量缓存
    if (Block && Block.TIME && Block.TIME.server > 0) {
        return cb(Block.TIME);
    }
    var id = guid();
    // 放入队列
    Queue[id] = cb;
    Time._syn();
    return id;
};
Time.off = function (id) {
    if (Queue.hasOwnProperty(id)) {
        delete Queue[id];
    }
};
export default Time;
